import { Redirect } from "react-router-dom";

import { PAGE_URLS } from "../constants/PageUrls";

export function RedirectCheckoutBranding() {
  return <Redirect to={PAGE_URLS.checkoutBrandingRedirectDestination} />;
}
